/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import 'styles/index.scss';

// eslint-disable-next-line import/prefer-default-export
export const onPrefetchPathname = ({ loadPage }) => {
  const { pathname } = window.location;

  const cutPath = pathname.slice(0, pathname.lastIndexOf('/')) || '/';

  if (!window.pageData) {
    window.pageData = {};

    loadPage(cutPath).then(result => {
      window.pageData[cutPath] = result;
      if (window.setPageData) window.setPageData();
    });
  }

  if (!window.pageData[pathname]) {
    loadPage(pathname).then(result => {
      window.pageData[pathname] = result;
      if (window.setPageData) window.setPageData();
    });
  }
};

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  return getSavedScrollPosition(location);
};
